import type { ComponentPropsWithoutRef } from "react";
import noop from "lodash/noop";
import { Icon } from "@circle-react-shared/Icon";

export interface ButtonProps extends ComponentPropsWithoutRef<"button"> {
  isDisabled?: boolean;
  onClick?: () => void;
}

export const Button = ({
  onClick = noop,
  isDisabled = false,
  ...rest
}: ButtonProps) => (
  <button
    type="button"
    className="text-dark border-secondary bg-primary hover:text-darkest hover:bg-tertiary flex size-6 items-center justify-center rounded-full border transition-colors duration-200 hover:shadow-sm"
    disabled={isDisabled}
    onClick={onClick}
    {...rest}
  >
    <Icon
      type="plus-v2"
      size={16}
      className="h-4 !w-4"
      useWithFillCurrentColor
    />
  </button>
);
